import { FC, memo } from 'react';
import classNames from 'classnames';

import { PlayerTypesInFlow } from '../../types';
import { TPlayerTypeItem } from '../types';

import styles from './PlayerTypeItem.module.scss';

interface PlayerTypeItemProps {
  player: TPlayerTypeItem;
  selectedPlayer: PlayerTypesInFlow;
  onPlayerChange: (playerType: PlayerTypesInFlow) => void;
  withVideoDevice?: boolean;
}

const PlayerTypeItem: FC<PlayerTypeItemProps> = ({
  player,
  selectedPlayer,
  onPlayerChange,
  withVideoDevice = false,
}) => {
  const handleClick = () => {
    onPlayerChange(player.type);
  };

  return (
    <div
      role="none"
      onClick={handleClick}
      key={`stream_bind_select_player_${player.type}`}
      id={`stream_bind_select_player_${player.type}`}
      data-selected={player.type === selectedPlayer}
      className={classNames(styles.itemContainer, {
        [styles.itemContainerSelected]: player.type === selectedPlayer,
      })}>
      {player.type === PlayerTypesInFlow.VIDEOPLAYER || player.type === PlayerTypesInFlow.MOBILE ? (
        <img
          src={withVideoDevice ? player.imageSrc : player.imageSrcFallback}
          alt=""
          loading="lazy"
          className={styles.image}
        />
      ) : (
        <img
          src={player.imageSrc}
          alt=""
          loading="lazy"
          className={styles.image}
        />
      )}

      <div className={styles.title}>{player.title}</div>

      {player.type === PlayerTypesInFlow.MOBILE ? (
        <div className={styles.subtitle}>{withVideoDevice ? player.descriptionFallback : player.description}</div>
      ) : (
        <div className={styles.subtitle}>{player.description}</div>
      )}
    </div>
  );
};

export default memo(PlayerTypeItem);
